import { render, staticRenderFns } from "./OrderTravelDate.vue?vue&type=template&id=13376d71&"
import script from "./OrderTravelDate.vue?vue&type=script&lang=ts&"
export * from "./OrderTravelDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderTravelDate.vue"
export default component.exports